import brown from '../../img/horses/brown.png';
import grey from '../../img/horses/grey.png';
import black from '../../img/horses/black.png';
import palomino from '../../img/horses/palomino.png';
import blackWhite from '../../img/horses/blackWhite.png';

// Portraits reused as-is (with permission) from the Keizaal reference UI's
// own asset set - same "brown/grey/black/palomino" breed set, "pinto" here
// maps to their "blackWhite" file since only the id names differ.
const HORSE_IMAGES: Record<string, string> = {
  brown,
  grey,
  black,
  palomino,
  pinto: blackWhite,
};

export function getHorseImage(breedId: string): string | null {
  return HORSE_IMAGES[breedId] ?? null;
}
